export const LEARNING_MODALITIES = ['textbook', 'chat', 'avatar'] as const;
export type LearningModality = (typeof LEARNING_MODALITIES)[number];

export interface SiteLearningMaterialManifest {
  slug: string;
  title: string;
  /** Optional contextual label for a non-textbook learning surface. */
  companionDescription?: string;
  order: number;
  enabled: boolean;
}

export interface SiteLearningWorkspaceManifest {
  schemaVersion: 1;
  enabled: boolean;
  persona: { slug: string };
  materials: SiteLearningMaterialManifest[];
}

export interface LearningMaterial extends SiteLearningMaterialManifest {
  contentFormat: 'markdown';
  contentMarkdown: string;
  curriculumGuideMarkdown?: string;
  /** Lesson-opening text shown to the learner before this material's content. */
  preambleMarkdown?: string;
}

export interface SiteLearningWorkspace {
  enabled: boolean;
  persona: SiteLearningWorkspaceManifest['persona'];
  materials: readonly LearningMaterial[];
}
